import PaginatedResponseIO from "./utils/paginated-response-io"

export default PaginatedResponseIO
